// mixins/alertPopup.js
export default {
  data() {
    return {
    }
  },
  methods: {
    mixins_alertPopup(options = {}) {
      const {
        msg = '操作失败',
        title = '提示',
        confirmButtonText = '确定',
        callback = null,
        dangerouslyUseHTMLString = true,
        ...rest  // 保留其他 Element UI 支持的高级配置
      } = options;
      return this.$alert(msg, title, {
        ...rest,
        callback: (action) => {
          if (callback && typeof callback === 'function') {
            callback(action);
          }
        }
      });
    }
  },
  // 组件销毁时
  beforeDestroy() {
  }
}


// WEBPACK FOOTER //
// ./mixins/alterPopup.js